import { render, staticRenderFns } from "./LodgingsV2.vue?vue&type=template&id=597e6f04&scoped=true&"
import script from "./LodgingsV2.vue?vue&type=script&lang=js&"
export * from "./LodgingsV2.vue?vue&type=script&lang=js&"
import style0 from "./LodgingsV2.vue?vue&type=style&index=0&id=597e6f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597e6f04",
  null
  
)

export default component.exports